import { useEffect } from "react";
import { mustGetElementById, mustQuerySelectorAtIndex } from "./helpers";
import { useProxyErrors } from "./useProxyErrors";
import { useProxyError } from "./useProxyError";
import { useProxyAction } from "./useProxyAction";

const getSignInNameInput = () => mustGetElementById<HTMLInputElement>('signInName');
const getPasswordInput = () => mustGetElementById<HTMLInputElement>('password');
const getRememberMeCheckbox = () => mustGetElementById<HTMLInputElement>('rememberMe');
const getNextButton = () => mustGetElementById<HTMLButtonElement>('next');
const getForgotPasswordLink = () => mustGetElementById<HTMLAnchorElement>('forgotPassword');

const getPageLevelErrors = () => Array.from<HTMLElement>(document.querySelectorAll('#api .pageLevel.error'));
const getSignInNameError = () => mustQuerySelectorAtIndex<HTMLDivElement>('.error.itemLevel', 0, "email error container");
const getPasswordError = () => mustQuerySelectorAtIndex<HTMLDivElement>('.error.itemLevel', 1, "password error container");

export function useUnifiedLayoutProxy({ email, password, rememberMe } : {
  email: string
  password: string
  rememberMe: boolean
}) {
  useEffect(() => {
    getSignInNameInput().value = email;
  }, [email]);

  useEffect(() => {
    getPasswordInput().value = password;
  }, [password]);

  useEffect(() => {
    getRememberMeCheckbox().checked = rememberMe;
  }, [rememberMe]);

  const signInAction = useProxyAction(getNextButton);
  const navigateToForgotPasswordAction = useProxyAction(getForgotPasswordLink);

  const signInError = useProxyErrors(getPageLevelErrors);
  const emailError = useProxyError(getSignInNameError);
  const passwordError = useProxyError(getPasswordError);

  return {
    signInAction, navigateToForgotPasswordAction,
    signInError, emailError, passwordError,
  };
}
